const iconConfig = [
  {
    name: '_bus',
    path: 'images/arrows/bus.png',
  },
  {
    name: 'stop',
    path: 'images/arrows/default.png',
  },
]

export const defaultIcon = {
  name: 'default',
  path: 'images/arrows/default.png',
}

export default iconConfig
